export default __webpack_public_path__ + "static/2175-fb543ffed15be7056971e87106309993.gif";